
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/about",
      function () {
        return require("private-next-pages/qmee/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/about"])
      });
    }
  